module.exports = __webpack_public_path__ + "img/icons B_11.852fdb35.png";